/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, useState } from "react";
import { history, useIntl } from "umi";
import http from "@/utils/http";
import Abnormal from "../Abnormal";
import { embedDatalab } from "../DatalabSDK";
import { IDatalabData, IDatalabIframeProps, IGuessTokenData } from "./types";
import Loading from "@/pages/dashboard/components/Loading";
import { notification } from "tea-component";
import "./index.scss";

// Todo gameCode需要后端判断虚拟版本
// Todo 刷新接口报错，需要怎么提示
// Todo iframe的url需要校验吗？
// Todo 选中菜单，用于更新报表（dashboard_custom_id + attributes）
const DatalabIframe = (props: IDatalabIframeProps) => {
  const { paramsOfIframe, gameCode, currentMenu, dashboardName, api, params, theme, clickExplore, clickFullscreen, ...restProps } = props;
  const urlParams = history?.location?.query || {};
  const communicatorRef = useRef<any>(null);
  const { formatMessage, locale } = useIntl();
  const [loading, setLoading] = useState(true); // 接口loading
  const [iframeLoading, setIframeLoading] = useState(true); // iframe加载loading，防止中间白屏
  const [error, setError] = useState(false); // 接口报错状态
  // const host = "http://10.250.220.211:6502";

  // 页面初始化或dashboardId变更时, 重新请求
  const initTokenData = () => {
    setLoading(true);
    setIframeLoading(true);
    http({
      url: api,
      method: 'post',
      data: params,
    }).then((res: IGuessTokenData | unknown) => {
      // const { dashboard_id: dashboardId, embed_url: embedUrl, guest_token: token } = (res as IGuessTokenData) || {};
      const { dashboard_id: dashboardId, embed_url: embedUrl, guest_token: token, host } = (res as IGuessTokenData) || {};
      const data: IDatalabData = {
        language: locale,
        theme,
        origin: host,
        dashboardId,
        token,
        paramsOfIframe: paramsOfIframe || {},
        ...(gameCode ? { gameCode } : {}),
        ...(dashboardName ? { dashboardName } : {}),
        ...restProps,
      };
      setLoading(false);
      setError(false);
      const datalabConfig = {
        ...urlParams,
      };
      embedDatalab({
        iframeSelector: '#dbh-datalab-iframe',
        iframeUrl: host + embedUrl,
        data,
        datalabConfig,
        fetchGuestToken: () => {
          return http({
            url: api,
            method: 'post',
            data: params,
          }).then((res: IGuessTokenData | unknown) => {
            const { dashboard_id: dashboardId, guest_token: token, host } = (res as IGuessTokenData) || {};
            const data: IDatalabData = {
              origin: host,
              dashboardId,
              token,
              paramsOfIframe: paramsOfIframe || {},
              ...(gameCode ? { gameCode } : {}),
              ...(dashboardName ? { dashboardName } : {}),
            };
            return data || {};
          }, () => {
            return data || {};
          }).catch((e) => {
            // 会话过期，重新请求错误提示
            notification.error({
              description: formatMessage({ id: 'dbh_session_expired' }),
              duration: 3000,
            });
            return {
              ...(data || {}),
              code: e?.code,
              msg: e?.msg,
            };
          });
        },
        clickExplore: (payload) => clickExplore?.(payload),
        clickFullscreen: (payload) => clickFullscreen?.(payload),
        iframeMounted: () => {
          setIframeLoading(false);
        }
      }).then((datalab) => {
        communicatorRef.current = datalab;
      }).finally(() => {
        // 10秒超时，取消iframe加载loading
        setTimeout(() => {
          if (iframeLoading) {
            setIframeLoading(false);
          }
        }, 10000);
      });

    }).catch(e => {
      console.log(e);
      setLoading(false);
      setError(true);
      setIframeLoading(false);
    });
  };

  useEffect(() => {
    initTokenData();
    return () => {
      // 清除通信器实例
      communicatorRef.current?.unmount();
    };
  }, [currentMenu]);

  // 切换语言
  useEffect(() => {
    communicatorRef.current?.instance?.changeLanguage({ language: locale });
  }, [locale]);
  
  // 切换主题
  useEffect(() => {
    communicatorRef.current?.instance?.changeTheme({ theme });
  }, [theme?.name]);

  return (<Abnormal
    isLoading={loading}
    isError={error}
    style={{ width: '100%', height: "100%" }}
    component={<>
      {iframeLoading && <div className={`dbh-datalab-iframe-loading`} >
        <Loading content={formatMessage({ id: 'common_loading' })} />
      </div>}
      <div className={`dtb-db-iframe-wrap`}>
        <iframe
          title="datalab"
          id={'dbh-datalab-iframe'}
          className='dtb-db-iframe'
          allow="fullscreen"
        />
      </div>
    </>}
  />);
};

export default DatalabIframe;